import { render, staticRenderFns } from "./CurrencyLocale.vue?vue&type=template&id=c949afa6"
import script from "./CurrencyLocale.vue?vue&type=script&lang=js"
export * from "./CurrencyLocale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports